<template>
  <div class="container page">
    <van-nav-bar title="填寫收款卡" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">請輸入收款卡資訊。</div>
      <van-cell-group>
        <van-field v-model="name" label="真實姓名"  placeholder="請輸入真實姓名。" />

        <van-field v-model="bankid" label="卡號" type="digit" placeholder="請輸入真實卡號。" />
        <van-field v-model="bank" label="開戶銀行"  placeholder="請選擇銀行。" />
        <!-- @click="showSelectBanks()"  -->
      </van-cell-group>
      <div class="wrapper">
        <div class="item">
          <p class="title">請輸入資金密碼。</p>
          <van-password-input :value="opw" :length="4" :gutter="10" :focused="oshowKeyboard"
            @focus="oshowKeyboard = true; tshowKeyboard = false;" />
          <van-number-keyboard v-model="opw" :show="oshowKeyboard"
            @input="opw.length !== 3 ? oshowKeyboard = true : tshowKeyboard = true;" @blur="oshowKeyboard = false" />
        </div>
        <div class="item">
          <p class="title">請再次輸入資金密碼。</p>
          <van-password-input :value="tpw" :length="4" :gutter="10" :focused="tshowKeyboard"
            @focus="tshowKeyboard = true; oshowKeyboard = false;" />
          <van-number-keyboard v-model="tpw" :show="tshowKeyboard"
            @input="tpw.length !== 3 ? tshowKeyboard = true : tshowKeyboard = false; oshowKeyboard = false"
            @blur="tshowKeyboard = false" />
        </div>
        <!-- <van-button class="sub-btn" type="default" @click="setPayPassword()">제출</van-button> -->
      </div>
      <p>尊敬的用戶，為保障資金安全，請綁定您的真實姓名與提現密碼。如姓名與開戶姓名不一致將無法提現。</p>
    </div>

    <van-button class="bindCard" type="default" @click="bindCard()">綁定卡</van-button>
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }">
      <van-picker show-toolbar :columns="banks" @confirm="onConfirm" @cancel="onCancel" :confirm-button-text="'確認'"
        :cancel-button-text="'取消'" />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name:"",
      banks: [],
      showBank: false,
      userInfo: {},
      bankid: "",
      bank: "",
      opw: '',
      tpw: '',
      oshowKeyboard: true,
      tshowKeyboard: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      if(this.name === "" || this.name === null || this.name === undefined){
        this.$toast.fail("請輸入姓名！");
        return false;
      }
      if (this.userInfo.bankid) {
        this.$toast("請輸入銀行卡號！");
        return true;
      }
      if (this.bank === "" || this.bank === null || this.bank === undefined) {
        this.$toast.fail("請選擇銀行！");
        return false;
      }
      if (this.opw.length !== 4) {
        this.oshowKeyboard = true;
        this.$toast("請輸入完整密碼");
        return false;
      }
      if (this.tpw.length !== 4) {
        this.tshowKeyboard = true;
        this.$toast("請輸入完整密碼");
        return false;
      }
      this.$http({
        method: 'post',
        data: { bankid: this.bankid, bank: this.bank,name:this.name, opw: this.opw, tpw: this.tpw },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: '/Mine' })
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    showSelectBanks() {
      this.showBank = true;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getBankList() {
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res => {
        if (res.code === 200) {
          this.banks = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    onConfirm(value) {
      this.bank = value.text
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 32px;
  line-height: 80px;
}

.van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}

.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.main-box {
  background: #fff;

}

.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}

::v-deep .van-picker__toolbar {
  height: 50px;
}

::v-deep .van-picker__cancel,
.van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}

::v-deep .van-picker-column {
  font-size: 40px;
}

.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}

.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}


.container .wrapper {
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}

.container .wrapper .item .title {
  margin: 40px 0;
  line-height: 20px;
  font-size: 30px;
  font-weight: 500;
  color: #c24491;
  text-align: center;
}

::v-deep .van-password-input {
  width: 80%;
  height: 150px;
  margin: 0 auto;

}

::v-deep .van-password-input__security li {
  font-size: 30px;
  line-height: 30;
  background-color: #ebedf0;
}

::v-deep .van-password-input__security {
  height: 130px;
}

::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 30px;
}

.van-password-input__security i {
  width: 25px;
  height: 25px;
}

::v-deep .van-key {
  height: 100px;
  font-size: 55px;
  line-height: 20px;
  border-radius: 20px;
}

::v-deep .van-number-keyboard {
  z-index: 100;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f2f3f5;
}

::v-deep .van-key__collapse-icon {
  width: 50px;
  height: 50px;
}

::v-deep .van-key__delete-icon {
  width: 50px;
  height: 50px;
}

.container .wrapper .sub-btn {
  margin: 110px 0 0 10%;
  height: 100px;
  width: 80%;
  font-size: 35px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}
</style>
